import { Dispatch } from 'redux';
import GlockAppController from '../controllers/GlockAppController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class GlockAppCRUDActions extends CrudActionContainer {
  retrievedEmailAccountDeliverabilityScoreAction: string;

  constructor() {
    super('GLOCK_APP');
    this.retrievedEmailAccountDeliverabilityScoreAction = this.makeActionKey(
      'RETRIVE_DELIVERABILITY_SCORE',
    );
  }

  getAccountDeliverabilityScore(
    facebookPageId: number,
    emailAccountId?: number,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        const result = await GlockAppController.getAccountDeliverabilityScore(
          facebookPageId,
          emailAccountId,
        );
        dispatch({
          type: this.retrievedEmailAccountDeliverabilityScoreAction,
          payload: result,
        });
        return result;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  runAccountDeliverabilityScore(
    facebookPageId: number,
    emailAccountId: number,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        const result = await GlockAppController.runAccountDeliverabilityScore(
          facebookPageId,
          emailAccountId,
        );
        dispatch({
          type: this.retrievedEmailAccountDeliverabilityScoreAction,
          payload: result,
        });
        return result;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }
}

export const glockAppCRUDActions = new GlockAppCRUDActions();

export const useGlockAppCRUDActions = getActionHookBuilder(
  glockAppCRUDActions,
  ['getAccountDeliverabilityScore', 'runAccountDeliverabilityScore'],
);
